export type ColumnSortType = "text" | "date" | "boolean";

export type ColumnSortConfig = {
  sortKey: string;
  sortType: ColumnSortType;
};

export type SortDirection = "ASC" | "DESC";

export function getSortOptionLabels(type: ColumnSortType): {
  asc: string;
  desc: string;
} {
  switch (type) {
    case "date":
      return { asc: "Oldest → Newest", desc: "Newest → Oldest" };
    case "boolean":
      return { asc: "No → Yes", desc: "Yes → No" };
    default:
      return { asc: "A → Z", desc: "Z → A" };
  }
}
